import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import BookCategory from './BookCategory';
import BookCategoryAddEdit from './BookCategory/addEdit';
import CategoryView from './BookCategory/CategoryView';
import BookDetailView from './BookCategory/BookDetailView';

import Book from './Book';
import BookAddEdit from './Book/addEdit';
import BookImportCSV from './Book/importBook';
import AddDeleteBook from './Book/AddDeleteBook';
import UpdateBook from './Book/UpdateBook';
import MyBookActivities from './Book/MyBookActivities';

import BookIssueReturn from './BookIssueReturn';
import BookIssueReturnAddEdit from './BookIssueReturn/addEdit';
import ReturnBook from './BookIssueReturn/returnBook';

import Fine from './Fine';
import FineAddEdit from './Fine/addEdit';

import FineSetting from './FineSetting';
import FineSettingAddEdit from './FineSetting/addEdit';

export  const Libraryroutes = [
    {
        path: '/bookcategory',
        name:'Book Category',
        component: BookCategory,
        show:true,
    },
    {
        path: '/bookcategory-action', 
        component: BookCategoryAddEdit
    },
    {
        path: '/bookcategory/:id', 
        component: CategoryView
    },
    {
        path: '/bookview/:id', 
        component: BookDetailView
    },
    {
        path: '/bookcategory-action/:id', 
        component: BookCategoryAddEdit
    },
    {
        path: '/book',
        name:'Book',
        component: Book,
        show:true,
    },
    {
        path: '/book-action', 
        component: BookAddEdit
    },
    {
        path: '/book-import', 
        name:'Book Import',
        component: BookImportCSV,
        show:true,
    },
    {
        path: '/mybook-activities', 
        name:'My Book Activities',
        component: MyBookActivities,
        show:true,
    },
    {
        path: '/book-action/:id', 
        component: BookAddEdit
    },
    {
        path: '/book-add-delete/:id', 
        component: AddDeleteBook
    },
    {
        path: '/book-add-delete/add/:id', 
        component: UpdateBook
    },
    {
        path: '/book-issue-return',
        name:'Book Issue/Return',
        component: BookIssueReturn,
        show:true,
    },
    {
        path: '/book-issue-return-action', 
        component: BookIssueReturnAddEdit
    },
    {
        path: '/book-issue-return-action/:id', 
        component: BookIssueReturnAddEdit
    },
    {
        path: '/book-issue-returned/:id', 
        component: ReturnBook
    },
    {
        path: '/fine',
        name:'Fine',
        component: Fine,
        show:true,
    },
    {
        path: '/fine-action', 
        component: FineAddEdit
    },
    {
        path: '/fine-action/:id', 
        component: FineAddEdit
    },
    {
        path: '/fine-setting',
        name:'FineSetting',
        component: FineSetting,
        show:true,
    },
    {
        path: '/fine-setting-action', 
        component: FineSettingAddEdit
    },
    {
        path: '/fine-setting-action/:id', 
        component: FineSettingAddEdit
    }
];

const Library = (props) => {
    return(
        <Switch>
            {Libraryroutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default Library; 


// WEBPACK FOOTER //
// ./src/components/Library/index.js